/**
 * Quick Add to Cart Functionality
 * Grid strip buttons, multi-variant in-card overlay, and AJAX add.
 */

window.addVariantToCartAjax = function (variantId, quantity) {
  quantity = quantity || 1
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity }],
    }),
  }).then((response) => response.json())
}

window.addToCartDirect = function (variantId, element) {
  const isFabIcon = element.classList.contains("grid-product__mobile-quick-cart-btn")
  const labelEl =
    element.querySelector(".js-grid-overlay-atc-label") ||
    (isFabIcon ? element.querySelector(".js-mobile-fab-label") : null) ||
    element
  const defaultText =
    element.getAttribute("data-default-text") ||
    labelEl.getAttribute("data-default-text") ||
    (labelEl.textContent || "").trim() ||
    "Add to cart"

  const useBtnLoading = element.classList.contains("btn")
  if (useBtnLoading) {
    element.classList.add("btn--loading")
  } else if (isFabIcon) {
    element.classList.add("is-fab-busy")
    element.setAttribute("aria-busy", "true")
  } else {
    labelEl.textContent = "Adding..."
    element.classList.add("is-adding")
  }

  window
    .addVariantToCartAjax(variantId, 1)
    .then((data) => {
      if (useBtnLoading) {
        element.classList.remove("btn--loading")
      } else if (isFabIcon) {
        element.classList.remove("is-fab-busy")
        element.removeAttribute("aria-busy")
        element.setAttribute("aria-label", "Added to cart")
        setTimeout(() => {
          element.setAttribute("aria-label", defaultText)
        }, 2000)
      } else {
        element.classList.remove("is-adding")
        labelEl.textContent = "Added!"
        setTimeout(() => {
          labelEl.textContent = defaultText
        }, 2000)
      }

      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: { product: data },
        })
      )

      if (typeof window.refreshCart === "function") {
        window.refreshCart()
      }
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error)
      if (useBtnLoading) {
        element.classList.remove("btn--loading")
      } else if (isFabIcon) {
        element.classList.remove("is-fab-busy")
        element.removeAttribute("aria-busy")
        element.setAttribute("aria-label", "Error")
        setTimeout(() => {
          element.setAttribute("aria-label", defaultText)
        }, 2000)
      } else {
        element.classList.remove("is-adding")
        labelEl.textContent = "Error"
        setTimeout(() => {
          labelEl.textContent = defaultText
        }, 2000)
      }
    })

  return false
}

function formatGridMoney(cents) {
  if (
    window.theme &&
    theme.Currency &&
    theme.settings &&
    theme.settings.moneyFormat
  ) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
  }
  return (cents / 100).toFixed(2)
}

function parseProductJson(overlay) {
  const id = overlay.getAttribute("data-product-id")
  const card = overlay.closest(".grid-product")
  const script =
    card &&
    card.querySelector(
      "script[type=\"application/json\"][data-grid-product-json=\"" + id + "\"]"
    )
  if (!script || !script.textContent) return null
  try {
    return JSON.parse(script.textContent.trim())
  } catch (e) {
    console.warn("Grid quick choose: invalid product JSON", e)
    return null
  }
}

function getSelectedOptions(overlay) {
  const byIndex = {}
  overlay.querySelectorAll(".js-grid-quick-option-btn.is-selected").forEach((btn) => {
    const idx = parseInt(btn.getAttribute("data-option-index"), 10)
    const val = btn.getAttribute("data-option-value")
    if (!Number.isNaN(idx) && val != null && val !== "") {
      byIndex[idx] = val
    }
  })
  return Object.keys(byIndex)
    .map((k) => parseInt(k, 10))
    .sort((a, b) => a - b)
    .map((k) => byIndex[k])
}

function variantOptionValues(v) {
  if (v.options && Array.isArray(v.options)) {
    return v.options
  }
  const arr = []
  if (v.option1 != null && v.option1 !== "") arr.push(v.option1)
  if (v.option2 != null && v.option2 !== "") arr.push(v.option2)
  if (v.option3 != null && v.option3 !== "") arr.push(v.option3)
  return arr
}

function findVariant(product, selections) {
  if (!product || !product.variants) return null
  return product.variants.find((v) => {
    const opts = variantOptionValues(v)
    return (
      opts.length === selections.length &&
      opts.every((opt, i) => opt === selections[i])
    )
  })
}

function isGridQuickMobileSheet() {
  return window.matchMedia("(max-width: 768px)").matches
}

const GRID_QUICK_MOBILE_CLOSE_MS = 450

function syncGridQuickMobileSheetBodyLock() {
  const open = document.querySelector(
    "[data-grid-quick-choose-overlay].is-open.is-mobile-sheet"
  )
  if (!open) {
    document.documentElement.classList.remove("grid-quick-mobile-sheet-open")
    document.body.style.removeProperty("padding-right")
    document.body.removeAttribute("data-grid-quick-sheet-lock")
  }
}

function lockGridQuickMobileSheetScroll() {
  document.documentElement.classList.add("grid-quick-mobile-sheet-open")
  if (document.body.getAttribute("data-grid-quick-sheet-lock") === "1") return
  const gap = window.innerWidth - document.documentElement.clientWidth
  if (gap > 0) {
    document.body.style.paddingRight = gap + "px"
  }
  document.body.setAttribute("data-grid-quick-sheet-lock", "1")
}

function closeAllGridQuickChoose(exceptOverlay) {
  document
    .querySelectorAll("[data-grid-quick-choose-overlay].is-open")
    .forEach(function (el) {
      if (el !== exceptOverlay) {
        closeGridQuickChoose(el)
      }
    })
}

function openGridQuickChoose(overlay) {
  closeAllGridQuickChoose(overlay)
  overlay.setAttribute("aria-hidden", "false")
  if (isGridQuickMobileSheet()) {
    overlay.classList.add("is-mobile-sheet")
    lockGridQuickMobileSheetScroll()
    void overlay.offsetHeight
    requestAnimationFrame(() => {
      overlay.classList.add("is-open")
    })
  } else {
    overlay.classList.remove("is-mobile-sheet")
    overlay.classList.add("is-open")
  }
  const card = overlay.closest(".grid-product")
  if (card) card.classList.add("is-grid-quick-open")
}

function closeGridQuickChoose(overlay) {
  if (!overlay) return

  const wasOpen = overlay.classList.contains("is-open")
  if (wasOpen) overlay.classList.remove("is-open")
  overlay.setAttribute("aria-hidden", "true")

  const finalize = () => {
    const hadMobileSheet = overlay.classList.contains("is-mobile-sheet")
    const panelEl = overlay.querySelector(".grid-product__quick-choose-panel")
    if (hadMobileSheet) {
      overlay.style.setProperty("transition", "none")
      if (panelEl) panelEl.style.setProperty("transition", "none")
      overlay.classList.remove("is-mobile-sheet")
      void overlay.offsetHeight
      requestAnimationFrame(() => {
        overlay.style.removeProperty("transition")
        if (panelEl) panelEl.style.removeProperty("transition")
      })
    } else {
      overlay.classList.remove("is-mobile-sheet")
    }
    const card = overlay.closest(".grid-product")
    if (card) card.classList.remove("is-grid-quick-open")
    syncGridQuickMobileSheetBodyLock()
  }

  const needsMobileCloseAnim =
    wasOpen &&
    overlay.classList.contains("is-mobile-sheet") &&
    window.matchMedia("(max-width: 768px)").matches

  if (needsMobileCloseAnim) {
    const panel = overlay.querySelector(".grid-product__quick-choose-panel")
    let completed = false
    let fallbackId
    const done = () => {
      if (completed) return
      completed = true
      clearTimeout(fallbackId)
      if (panel) panel.removeEventListener("transitionend", onEnd)
      finalize()
    }
    const onEnd = (e) => {
      if (e.target === panel && e.propertyName === "transform") done()
    }
    fallbackId = setTimeout(done, GRID_QUICK_MOBILE_CLOSE_MS)
    if (panel) panel.addEventListener("transitionend", onEnd)
    else done()
  } else {
    finalize()
  }
}

function updateGridQuickOverlayVariant(overlay) {
  const product = parseProductJson(overlay)
  if (!product) return

  const selections = getSelectedOptions(overlay)
  const variant = findVariant(product, selections)

  const priceEl = overlay.querySelector("[data-grid-quick-price]")
  const compareEl = overlay.querySelector("[data-grid-quick-compare]")
  const atc = overlay.querySelector(".js-grid-quick-overlay-atc")
  const atcDefault =
    overlay.getAttribute("data-atc-default") ||
    (atc && atc.getAttribute("data-default-text")) ||
    "Add to cart"
  const soldOutLabel = overlay.getAttribute("data-sold-out-label") || "Sold out"
  const unavailableLabel =
    overlay.getAttribute("data-unavailable-label") || "Unavailable"

  if (!variant) {
    if (priceEl) priceEl.textContent = ""
    if (compareEl) {
      compareEl.textContent = ""
      compareEl.setAttribute("hidden", "")
    }
    if (atc) {
      const labelEl = atc.querySelector(".js-grid-overlay-atc-label") || atc
      atc.disabled = true
      labelEl.textContent = unavailableLabel
      atc.removeAttribute("data-id")
      atc.classList.remove("btn--loading", "is-adding")
    }
    return
  }

  if (priceEl) priceEl.textContent = formatGridMoney(variant.price)

  if (compareEl) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.textContent = formatGridMoney(variant.compare_at_price)
      compareEl.removeAttribute("hidden")
    } else {
      compareEl.textContent = ""
      compareEl.setAttribute("hidden", "")
    }
  }

  if (atc) {
    const labelEl = atc.querySelector(".js-grid-overlay-atc-label") || atc
    atc.setAttribute("data-id", String(variant.id))
    atc.setAttribute("data-default-text", atcDefault)
    if (labelEl !== atc) labelEl.setAttribute("data-default-text", atcDefault)
    atc.classList.remove("btn--loading", "is-adding")
    if (variant.available) {
      atc.disabled = false
      labelEl.textContent = atcDefault
    } else {
      atc.disabled = true
      labelEl.textContent = soldOutLabel
    }
  }
}

const GridQuickChoose = {
  onDocumentClick(e) {
    const openBtn = e.target.closest(".js-grid-quick-choose-open")
    if (openBtn) {
      e.preventDefault()
      e.stopPropagation()
      const card = openBtn.closest(".grid-product")
      const overlay = card && card.querySelector("[data-grid-quick-choose-overlay]")
      if (overlay) {
        openGridQuickChoose(overlay)
        updateGridQuickOverlayVariant(overlay)
      }
      return
    }

    const optionBtn = e.target.closest(".js-grid-quick-option-btn")
    if (optionBtn) {
      const overlay = optionBtn.closest("[data-grid-quick-choose-overlay]")
      if (!overlay || !overlay.classList.contains("is-open")) return
      e.preventDefault()
      const idx = optionBtn.getAttribute("data-option-index")
      if (idx == null) return
      overlay
        .querySelectorAll(
          '.js-grid-quick-option-btn[data-option-index="' + idx + '"]'
        )
        .forEach((b) => {
          b.classList.remove("is-selected")
          b.setAttribute("aria-pressed", "false")
        })
      optionBtn.classList.add("is-selected")
      optionBtn.setAttribute("aria-pressed", "true")
      updateGridQuickOverlayVariant(overlay)
      return
    }

    const closeBtn = e.target.closest(".js-grid-quick-choose-close")
    if (closeBtn) {
      e.preventDefault()
      const overlay = closeBtn.closest("[data-grid-quick-choose-overlay]")
      if (overlay) closeGridQuickChoose(overlay)
      return
    }

    const overlayAtc = e.target.closest(".js-grid-quick-overlay-atc")
    if (overlayAtc && !overlayAtc.disabled) {
      e.preventDefault()
      const variantId = overlayAtc.getAttribute("data-id")
      if (!variantId) return
      window.addToCartDirect(parseInt(variantId, 10), overlayAtc)
      return
    }

    if (e.target.classList.contains("js-grid-quick-choose-backdrop")) {
      const openOverlay = e.target.closest("[data-grid-quick-choose-overlay]")
      if (openOverlay && openOverlay.classList.contains("is-open")) {
        closeGridQuickChoose(openOverlay)
      }
    }
  },

  onKeydown(e) {
    if (e.key !== "Escape") return
    const openOverlay = document.querySelector(
      "[data-grid-quick-choose-overlay].is-open"
    )
    if (openOverlay) {
      e.preventDefault()
      closeGridQuickChoose(openOverlay)
    }
  },

  bind() {
    if (this._docClick) {
      document.removeEventListener("click", this._docClick, true)
    }
    if (this._keydown) {
      document.removeEventListener("keydown", this._keydown)
    }

    this._docClick = this.onDocumentClick.bind(this)
    this._keydown = this.onKeydown.bind(this)

    document.addEventListener("click", this._docClick, true)
    document.addEventListener("keydown", this._keydown)
  },

  refresh() {
    document
      .querySelectorAll("[data-grid-quick-choose-overlay]")
      .forEach((overlay) => updateGridQuickOverlayVariant(overlay))
  },
}

;(function () {
  class QuickAdd {
    constructor() {
      this.initEvents()
      this.setupMutationObserver()
    }

    setupMutationObserver() {
      const observer = new MutationObserver((mutations) => {
        let shouldInit = false
        mutations.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains("js-quick-add-btn")) {
                  shouldInit = true
                } else if (node.querySelectorAll) {
                  if (
                    node.querySelectorAll(".js-quick-add-btn").length ||
                    node.querySelectorAll("[data-grid-quick-choose-overlay]").length
                  ) {
                    shouldInit = true
                  }
                }
              }
            })
          }
        })
        if (shouldInit) {
          this.initEvents()
          GridQuickChoose.refresh()
        }
      })
      observer.observe(document.body, { childList: true, subtree: true })
    }

    initEvents() {
      const quickAddButtons = document.querySelectorAll(".js-quick-add-btn")

      quickAddButtons.forEach((button) => {
        if (button.hasAttribute("onclick")) return
        if (button.getAttribute("data-quick-bound") === "1") return

        const variantId = button.getAttribute("data-id")
        const defaultText =
          button.getAttribute("data-default-text") ||
          button.textContent.trim() ||
          "Add to cart"
        button.setAttribute("data-default-text", defaultText)
        button.setAttribute("data-quick-bound", "1")
        button.setAttribute(
          "onclick",
          "return window.addToCartDirect(" + variantId + ", this);"
        )
      })
    }

    init() {
      this.initEvents()
    }
  }

  let quickAddSingleton = null

  function initAll() {
    GridQuickChoose.bind()
    if (!quickAddSingleton) quickAddSingleton = new QuickAdd()
    else quickAddSingleton.initEvents()
    GridQuickChoose.refresh()
  }

  document.addEventListener("DOMContentLoaded", initAll)

  if (!window.__quickAddSectionHooks) {
    window.__quickAddSectionHooks = true
    document.addEventListener("shopify:section:load", initAll)
    document.addEventListener("shopify:section:select", initAll)
    document.addEventListener("shopify:block:select", initAll)
    document.addEventListener("recommendations:loaded", initAll)
  }
})()
